import {I_ACCESS_TOKEN_PARAMS,I_COMMON_DELETE_PARAMS,_customFetch, getFetchDELETEOptions, getFetchGETOptions} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import APP_CONFIG from 'config';

// ---------------------------------
// --- SKILLS
// ---------------------------------

const ENDPOINT_SKILLS = '/skills';

const logger = LoggerService.getInstance();

/**
 * Requete le endpoint skills
 * Récupère la liste des competences
 * @param param0
 */
const get = async ({accessToken}:I_ACCESS_TOKEN_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - skills - get...'));
  const options = getFetchGETOptions({accessToken});
  const URL = ENDPOINT_SKILLS + APP_CONFIG.ENDPOINT_SUFFIX;
  return _customFetch(URL,options);
};

interface I_SKILL_POST_PARAMS {
  accessToken: string,
  name: string,
  description: string,
  parent: number,
}
/**
 * Requete le endpoint skills POST
 * Ajoute une compétence
 * @param param0
 * @returns
 */
const post = async ({accessToken,name,description,parent}:I_SKILL_POST_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - skills - post...'));
  const params = {
    method: 'POST',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      name: encodeURIComponent(name.trim()),
      description: encodeURIComponent(description.trim()),
      parent_id: parent > 0 ? parent : undefined
    })
  };
  const URL = ENDPOINT_SKILLS + APP_CONFIG.ENDPOINT_SUFFIX;
  return _customFetch(URL,params);
};

/**
 * Requete le endpoint skills DELETE
 * Supprime une compétence
 * @param param0
 * @returns
 */
const remove = async ({accessToken,id}:I_COMMON_DELETE_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - skills - remove...'));
  const options = getFetchDELETEOptions({accessToken});
  const URL = `${ENDPOINT_SKILLS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,options);
};

interface I_SKILL_PUT_PARAMS {
  accessToken: string,
  id: number,
  name: string,
  description: string,
  parent: number,
}
/**
 * Requete le endpoint skills PUT
 * Modifie une compétence
 * @param param0
 * @returns
 */
const put = async ({accessToken,id,name,description,parent}:I_SKILL_PUT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - skills - put...'));
  const params = {
    method: 'PUT',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      name: encodeURIComponent(name.trim()),
      description: encodeURIComponent(description.trim()),
      parent_id: parent
    })
  };
  const URL = `${ENDPOINT_SKILLS}/${id}${APP_CONFIG.ENDPOINT_SUFFIX}`;
  return _customFetch(URL,params);
};

const skillsEndpoints = {
  get,
  post,
  remove,
  put,
};

export default skillsEndpoints;
